import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { useAddNewassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice'
import { useGetAssetsFinalQuery } from '../../../../features/addassets/addassetfinalApiSlice';
import { useNavigate } from "react-router-dom";
import { HeadingWrap, Span, CommonButton } from '../../../../Styles/CommonStyles';
import nameStringFn from '../../../../data/nameStringFn';
import UnivReqSelector from './UnivReqSelector';
import FilteredAssetReqFetcher from '../FilteredAssetReqFetcher';


const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const RequestWrapper = styled.div``

const TextInputWrap = styled.div`
  height: 40vh;
  margin-top: 30px;
  margin-bottom: 30px;  /* 👈 gives space for button */
`

const RemarkContainer = styled.div`
  margin-top: 15px;
  margin-left: 10px;
  margin-bottom: 20px;
  width: 90%;
`;

const SubmitButton = styled(CommonButton)`                                                                                                                                                                                                                                                                                                                                                
`
const ButtonCont = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 40px;
`

const IssueReq = () => {
  const [field, setField] = useState([{ catName: "", assetName: "", quantity: "" }])
  const [content, setContent] = useState('');
  const [storeSelectedValue, setStoreSelectedValue] = useState('');
  const [individualRequest, setIndividualRequest] = useState(false);
  const [allData, setAllData] = useState([]);
  const [filters, setFilters] = useState({
    perm_creator_id: [],
    perm_req_store: [],
    perm_curr_status: []
  });

  //logged in user data
  const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))

  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  //add mutation call
  const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation()

  //all office call
  const {
    data: allofficedata,
    isLoading: allofficeLoad,
  } = useGetofficesQuery('officelist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
  let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
  const officedata = tempallofficedata

  //find Bo of user office
  let useroffice = officedata?.filter(elm => elm.name === user_current_office)
  let Bo_id = useroffice[0]?.Bo

  // create sending userobject
  let sendBoObj = { id: Bo_id, name: getSingleuser && getSingleuser[Bo_id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[Bo_id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[Bo_id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[Bo_id]?.numSuffix[user_current_office] }

  const areAllRowsValid = field.every(row =>
    typeof row.catName === 'string' && row.catName.trim().length > 0 &&
    typeof row.assetName === 'string' && row.assetName.trim().length > 0 &&
    row.quantity !== "" && !isNaN(Number(row.quantity))
  );

  useEffect(() => {
    setFilters({
      perm_creator_id: [id],
      perm_req_type: ["Issue"],
      perm_req_store: [storeSelectedValue],
      perm_curr_status: ["Pending"]
    });
  }, [user_current_office, storeSelectedValue]);
  
  const handleChange = (event, index, newvalue, name) => {
    let tempField = structuredClone(field);
    if (event?.target?.name) {
      tempField[index][event.target.name] = event.target.value;
      setField(tempField);
    } else {
      tempField[index][name] = newvalue
      setField(tempField);
    }
  }

  //************************************************************************ */
  //create a unique Id
  const uniqueReqID = () => {
    const dateString = Date.now().toString(36);
    const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
    const uid = `${emailofuser}-${dateString}`
    return uid;
  };
  let uniqueReqId = uniqueReqID()
  //****************************************************************************** */
  // initial data request object created here
  let userReqData = {
    uniqueReqId: uniqueReqId,
    req_type: individualRequest? 'Individual_Issue': "Issue",
    req_creator_id: id,
    req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
    req_store: storeSelectedValue,
    assets_requested:[{ time_stamp: new Date(), actionNo:1, data:field }],
    bo_partial_issue: false,
    bo_assets_issue:[],
    store_partial_issue: false,
    store_assets_issue:[],
    curr_status: 'Pending',
    created_at: new Date(),
    curr_sent_by: id,
    curr_sent_to: Bo_id,
    curr_sent_to_string: `${nameStringFn(getSingleuser?.[Bo_id])}-${user_current_office}-${getSingleuser?.[Bo_id]?.designation?.[user_current_office] || 'Unknown'}`,
    curr_sent_to_tag: 'ureq_created',
    flow_users:[id],
    req_data: [{
      sent_to_tag:"ureq_created",
      Text: content,
      sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
      sent_to: sendBoObj,
      action:'New Issue Request Created',
      time_stamp: new Date()
    }],
    opened: false
  }

  //reqOption
  const navigate = useNavigate();

  const handleReqSubmit = async () => {
    if (allData?.requests?.length) return alert('You have a pending request. Please wait for it to be processed before submitting a new one.')
    if (Bo_id) {
      try {
        await addNewRequest(userReqData).unwrap()
        setField([{ catName: "", assetName: "", quantity: "" }])
        setContent('')
        navigate('/management/assets/myrequests')
        return alert('Request Forwarded to Your Branch Officer')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    } else {
      return alert('Please register your branch officer')
    }
  }

  console.log('field', field)

  return (
    <Container>
      <FilteredAssetReqFetcher filters={filters} onDataFetched={setAllData}/>
      <HeadingWrap>
        <Span>Request for Asset Issue</Span>
      </HeadingWrap>
      <Wrapper>       
        <RequestWrapper>

          <UnivReqSelector field = {field} setField = {setField} handleChange = {handleChange} storeSelectedValue = {storeSelectedValue} setStoreSelectedValue = {setStoreSelectedValue}
          individualRequest={individualRequest} setIndividualRequest={setIndividualRequest} 
          />
          
          {(storeSelectedValue?.length && areAllRowsValid)?<TextInputWrap>
            <HeadingWrap>
              <Span>Details/Justifications</Span>
            </HeadingWrap>
            <RemarkContainer>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Add Remark"
                variant="outlined"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Please provide details about your request..."
              />
            </RemarkContainer>
          </TextInputWrap>:null}
        </RequestWrapper>
        {(storeSelectedValue?.length && areAllRowsValid)? <ButtonCont><SubmitButton onClick={handleReqSubmit}>Sent To Branch Officer</SubmitButton></ButtonCont>:null}
      </Wrapper>
    </Container>
  )
}

export default IssueReq